import { allModelsSelector } from 'common-src/utils/selectorUtils';

export const getPatientSupplements = (state, patientId) =>
  allModelsSelector(state, 'PatientSupplement', (s) => s.patientId === patientId);
